//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  Alert,
} from 'react-bootstrap';
import PageTemplate from 'PageTemplates/PageTemplate';
import { PageHeader } from 'components/header';
import { useDispatch } from 'react-redux';
import { useAlert } from 'react-alert';
import { setSpinner } from 'services/store/actions/view';
import {
  getStorageOrderById,
  receiveStorageOrder,
} from 'services/apiRequests/storage.api';
import ConfirmationModal from 'components/modals/ConfirmationModal';

const StorageOrderReceive = () => {
  const { orderId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const alert = useAlert();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [receiveData, setReceiveData] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    fetchOrderDetails();
  }, [orderId]);

  const fetchOrderDetails = async () => {
    setLoading(true);
    dispatch(setSpinner(true));

    try {
      const response = await getStorageOrderById(orderId);
      const orderData = response.order;
      setOrder(orderData);

      // Inicjalizuj dane odbioru
      const initialReceiveData = orderData.items.map((item) => ({
        itemId: item._id,
        receivedQuantity: item.quantity, // Domyślnie pełna ilość
        actualUnitPrice: item.unitPrice, // Domyślnie oryginalna cena
      }));
      setReceiveData(initialReceiveData);
    } catch (error) {
      console.error('Error fetching order details:', error);
      alert.error('Błąd pobierania szczegółów zamówienia');
      history.push('/storage');
    } finally {
      setLoading(false);
      dispatch(setSpinner(false));
    }
  };

  const updateReceiveData = (itemId, field, value) => {
    setReceiveData((prev) =>
      prev.map((item) =>
        item.itemId === itemId
          ? { ...item, [field]: parseFloat(value) || 0 }
          : item,
      ),
    );
  };

  const calculateTotals = () => {
    const originalTotal = order.totalValue;
    const actualTotal = receiveData.reduce((sum, item) => {
      return sum + item.receivedQuantity * item.actualUnitPrice;
    }, 0);

    return { originalTotal, actualTotal };
  };

  const handleSubmit = async () => {
    try {
      dispatch(setSpinner(true));

      const receivePayload = {
        items: receiveData,
        receivedAt: new Date(),
      };

      await receiveStorageOrder(orderId, receivePayload);
      alert.success('Zamówienie zostało odebrane');
      history.push(`/storage/orders/${orderId}`);
    } catch (error) {
      console.error('Error receiving order:', error);
      alert.error('Błąd podczas odbioru zamówienia');
    } finally {
      dispatch(setSpinner(false));
      setShowConfirmModal(false);
    }
  };

  const handleBack = () => {
    history.push(`/storage/orders/${orderId}`);
  };

  if (loading || !order) {
    return (
      <PageTemplate>
        <div className="d-flex justify-content-center my-4">
          <div className="spinner-border" role="status" />
        </div>
      </PageTemplate>
    );
  }

  const { originalTotal, actualTotal } = calculateTotals();

  return (
    <PageTemplate>
      <PageHeader
        title={`Odbiór zamówienia ${order.number}`}
        extra={[
          <Button
            key="back"
            variant="outline-secondary"
            onClick={handleBack}
          >
            Anuluj
          </Button>,
          <Button
            key="submit"
            variant="success"
            onClick={() => setShowConfirmModal(true)}
          >
            Potwierdź odbiór
          </Button>,
        ]}
      />

      <Container fluid>
        {/* Informacje o zamówieniu */}
        <Row className="mb-4">
          <Col>
            <Alert variant="info">
              <h6>Informacje o zamówieniu</h6>
              <p className="mb-1">
                <strong>Numer:</strong> {order.number} |{' '}
                <strong>Producent:</strong> {order.producer?.name} |{' '}
                <strong>Status:</strong> {order.status}
              </p>
              <p className="mb-0">
                <strong>Utworzone:</strong>{' '}
                {new Date(order.createdAt).toLocaleDateString('pl-PL')}{' '}
                przez {order.user?.firstname} {order.user?.lastname}
              </p>
            </Alert>
          </Col>
        </Row>

        {/* Tabela elementów do odbioru */}
        <Row>
          <Col>
            <h5>Elementy do odbioru</h5>
            <Table responsive striped bordered>
              <thead>
                <tr>
                  <th>L.p.</th>
                  <th>Nazwa elementu</th>
                  <th>Typ</th>
                  <th>Zamówiona ilość</th>
                  <th>Cena jednostkowa</th>
                  <th>Odebrana ilość</th>
                  <th>Rzeczywista cena jedn.</th>
                  <th>Rzeczywista wartość</th>
                </tr>
              </thead>
              <tbody>
                {order.items.map((item, index) => {
                  const receiveItem = receiveData.find(
                    (r) => r.itemId === item._id,
                  );
                  const receivedQuantity =
                    receiveItem?.receivedQuantity || 0;
                  const actualUnitPrice =
                    receiveItem?.actualUnitPrice || 0;
                  const actualValue = receivedQuantity * actualUnitPrice;

                  const priceColorClass =
                    actualUnitPrice > item.unitPrice
                      ? 'text-danger'
                      : actualUnitPrice < item.unitPrice
                      ? 'text-success'
                      : '';

                  return (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.item.name}</td>
                      <td>{item.item.type}</td>
                      <td>{item.quantity} szt.</td>
                      <td>{item.unitPrice.toFixed(2)} zł</td>
                      <td style={{ textAlign: 'center' }}>
                        <Form.Control
                          type="number"
                          min="0"
                          max={item.quantity}
                          step="1"
                          value={receivedQuantity}
                          onChange={(e) =>
                            updateReceiveData(
                              item._id,
                              'receivedQuantity',
                              e.target.value,
                            )
                          }
                          style={{ width: '80px', margin: '0 auto' }}
                        />
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <Form.Control
                          type="number"
                          min="0"
                          step="0.01"
                          value={actualUnitPrice}
                          onChange={(e) =>
                            updateReceiveData(
                              item._id,
                              'actualUnitPrice',
                              e.target.value,
                            )
                          }
                          style={{ width: '100px', margin: '0 auto' }}
                          className={priceColorClass}
                        />
                      </td>
                      <td className={priceColorClass}>
                        {actualValue.toFixed(2)} zł
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* Podsumowanie */}
        <Row className="mt-4">
          <Col md={6} className="ms-auto">
            <Alert variant="info">
              <h6>Podsumowanie odbioru</h6>
              <p className="mb-1">
                <strong>Wartość zamówiona:</strong>{' '}
                {originalTotal.toFixed(2)} zł
              </p>
              <p className="mb-0">
                <strong>Wartość rzeczywista:</strong>{' '}
                {actualTotal.toFixed(2)} zł
              </p>
            </Alert>
          </Col>
        </Row>
      </Container>

      {/* Modal potwierdzenia */}
      {showConfirmModal && (
        <ConfirmationModal
          title="Potwierdzenie odbioru"
          description={`Czy na pewno chcesz potwierdzić odbiór zamówienia? Wartość rzeczywista: ${actualTotal.toFixed(
            2,
          )} zł`}
          closeModal={() => setShowConfirmModal(false)}
          handleSubmit={handleSubmit}
        />
      )}
    </PageTemplate>
  );
};

export default StorageOrderReceive;
